import { apiClient } from 'core/api/client';
import type { MeResponse } from 'types/api.generated';

export type AppRole = 'customer' | 'provider';

export const getMyProfile = async (): Promise<MeResponse> => {
  const { data } = await apiClient.get<MeResponse>('/api/v1/user/me');
  return data;
};

export const updateMyProfile = async (
  payload: Pick<MeResponse, 'firstName' | 'lastName'>,
): Promise<void> => {
  await apiClient.patch('/api/v1/user/me', payload);
};

export const deleteMyAccount = async (): Promise<void> => {
  await apiClient.delete('/api/v1/user/me');
};

export const changeMyRole = async (role: AppRole): Promise<void> => {
  await apiClient.post('/api/v1/user/me/role', { role });
};
